<template>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">Pluviometros</h1>
            </div><!-- /.col -->
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                <li class="breadcrumb-item active">Pluviometros</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
      </div>
      <!-- /.content-header -->

      <!-- Main content -->
      <div class="content">
        <div class="container-fluid">

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Fecha</h5>

                  <div class="card-text">
                    <div class="row">
                      <div class="col-lg-12">
                        <datepicker v-model="fecha"></datepicker>
                        <h1>{{mes}}</h1>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Alertas</h5>
                  <div class="card-text">
                    <div class="texto_chico">
                      <b-table striped hover bordered small :items="alertasItems" :fields="alertasFields"></b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Tabla</h5>
                  <div class="card-text">
                    <div class="texto_chico">
                      <b-table striped hover bordered small :items="tableItems" :fields="tableFields"></b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Umbrales</h5>
                  <div class="card-text">
                    <scatterjs :chartData="umbralData" :options="umbralOptions" ref="scatterjs" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

          <div class="row">
            <div class="col-lg-12">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Mediciones [últimos 7 días]</h5>
                  <div class="card-text">
                    <chartjs :chartData="chartData" :options="chartOptions" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

          <div class="row">
            <div class="col-lg-6">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Totales del mes</h5>
                  <div class="card-text">
                    <chartjs :chartData="chartDataTotales" :options="chartOptionsTotales" />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title">Mapa del día</h5>
                  <div class="card-text">
                    <div id="map"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.row -->

        </div><!-- /.container-fluid -->
      </div>
      <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import Chartjs from '../components/Chartjs'
import Scatterjs from '../components/Scatterjs'

import 'ol/ol.css'
import { Map, View } from 'ol'
import GeoJSON from 'ol/format/GeoJSON'
import { XYZ, Vector as VectorSource } from 'ol/source'
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer'
import { Fill, RegularShape, Stroke, Style, Text } from 'ol/style'
import { defaults as defaultControls, FullScreen } from 'ol/control'

import pluviometrosJson from '../assets/geojson/pluviometros.json'
import cashiriariJson from '../assets/geojson/cashiriari.json'
import mipayaPagoreniJson from '../assets/geojson/mipaya_pagoreni.json'
import mipayaJson from '../assets/geojson/mipaya.json'
import pagoreniJson from '../assets/geojson/pagoreni.json'
import sanMartinMalvinasJson from '../assets/geojson/san_martin_malvinas.json'
import sanMartinJson from '../assets/geojson/san_martin.json'
import u200 from '../assets/geojson/u200.json'
import u600 from '../assets/geojson/u600.json'
import SAGARI from '../assets/geojson/SAGARI.json'

export default {
  name: 'Inicio',
  components: { Chartjs, Datepicker, Scatterjs },
  data () {
    return {
      mapa: null,
      pluviometros: new GeoJSON(),
      pluviometrosArea: null,
      urlconfig: null,
      stats: { min: 0, max: 0, pluviometros: [] },
      fecha: null,
      tableItems: [],
      tableFields: [],
      alertasItems: [],
      alertasFields: [],
      chartData: {},
      umbralData: {},
      umbralOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: '24 horas acumulado'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: '30 días acumulado'
            }
          }]
        },
        animation: {
          duration: 1,
          onComplete: () => {
            var chartInstance = this.$refs['scatterjs']
            var ctx = chartInstance.getCtx()
            var controller = chartInstance.getController()

            // ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
            ctx.textAlign = 'center'
            ctx.textBaseline = 'bottom'
            ctx.fillStyle = '#444444'

            this.umbralData.datasets.forEach(function (dataset, i) {
              var meta = controller.getDatasetMeta(i)
              if (dataset.label !== 'monitoreo' && dataset.label !== 'advertencia' && dataset.label !== 'critico') {
                meta.data.forEach(function (bar, index) {
                  ctx.fillText(dataset.label, bar._model.x, bar._model.y - 5)
                })
              }
            })
          }
        }
      },
      chartOptions: { responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Precipitación (mm)'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Días'
            }
          }]
        },
        tooltips: {
          callbacks: {
            title: function (tooltipItem, data) {
              return tooltipItem[0]['yLabel']
            },
            label: function (tooltipItem, data) {
              return data['datasets'][tooltipItem['datasetIndex']]['label'] + ': ' + tooltipItem['xLabel']
            }
          }
        }
      },
      chartDataTotales: {},
      chartOptionsTotales: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Precipitación (mm)'
            }
          }],
          xAxes: [{
            ticks: {
              autoSkip: false
            }
          }]
        }
      },
      balancesHidricos: []
    }
  },
  mounted: function () {
    var obj = this
    this.$http.post(this.$store.state.apiurl + '/api-token-auth/', { "username": "estrata",
    "password": "@@Estrata99" }).then(function (valx) {
      obj.urlconfig = {
        credentials: true,
        headers: { 'Authorization': 'Token ' + valx.body.token }
      }
      obj.fecha = Date.now()
      /* this.$http.get(this.$store.state.apiurl + '/mediciones_stats', this.urlconfig).then(function (val) {
        this.stats = val.data
        this.pluviometro = this.stats.pluviometros[0].id
        this.semana = this.stats.max
      }) */
    })
    var legend = 'LLUVIA<table>'
    for (var j = 0; j < 6; j++) {
      var color = 'rgba(' +
        String(236 - 99 * j + 19 * j * j) + ',' +
        String(241 - 26 * j - 1 * j * j) + ',' +
        String(121 + 73 * j - 11 * j * j) + ',' +
        '0.8)'
      legend = legend + '<tr><td style="background-color:' + color + '">&nbsp;&nbsp;&nbsp;&nbsp;</td><td> > ' + String(j * 30) + ' mm </td></tr>'
    }
    legend = legend + '</table>'
    obj.mapa = new Map({
      target: 'map',
      layers: [
        /* new TileLayer({
          source: new OSM()
        }), */
        new TileLayer({
          source: new XYZ({
            attributions: legend + 'Tiles &copy; Esri',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
          })
        })
      ],
      view: new View({
        projection: 'EPSG:4326',
        center: [ -72.93, -11.7 ],
        zoom: 10
      }),
      controls: defaultControls().extend([
        new FullScreen()
      ])
    })

    var trazas = [
      { json: u200, color: 'rgba(15,231,69,1.0)' },
      { json: u600, color: 'rgba(34,80,231,1.0)' },
      { json: SAGARI, color: 'rgba(100,80,231,1.0)' }
    ]
    for (var i = 0; i < trazas.length; i++) {
      var lyr = new VectorLayer({
        source: new VectorSource({ features: (new GeoJSON()).readFeatures(trazas[i].json) }),
        style: this.style(trazas[i].color)
      })
      obj.mapa.addLayer(lyr)
      lyr.setZIndex(99)
    }
    obj.mapa.addLayer(
      new VectorLayer({
        source: new VectorSource({
          features: (new GeoJSON()).readFeatures(pluviometrosJson)
        }),
        style: function (feature) {
          return new Style({
            image: new RegularShape({
              radius: 8.8,
              points: 4,
              stroke: new Stroke({ color: 'rgba(7,88,0,1.0)', lineDash: null, lineCap: 'butt', lineJoin: 'miter', width: 5 }),
              fill: new Fill({ color: 'rgba(84,176,74,1.0)' })
            }),
            text: new Text({
              font: '13.0px \'MS Shell Dlg 2\', sans-serif',
              text: String(feature.get('nombre')),
              textBaseline: 'middle',
              textAlign: 'left',
              offsetX: 8,
              offsetY: 3,
              placement: 'point',
              maxAngle: 0,
              stroke: new Stroke({ color: 'rgba(255,255,255,0.7)', lineDash: null, lineCap: 'butt', lineJoin: 'miter', width: 5 }),
              fill: new Fill({
                color: 'rgba(0, 0, 0, 1)'
              })
            })
          })
        },
        zIndex: 999
      })
    )
  },
  methods: {

    
    actualizar (fecha) {
      /* if (this.pluviometro && this.semana) { */
      var obj = this
      var t = new Date()
      var time = null
      if (fecha.getDate() === t.getDate() &&
        fecha.getMonth() === t.getMonth() &&
        fecha.getFullYear() === t.getFullYear()) {
        time = t.toISOString().split('T')[0]
      } else {
        time = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate())
        time = time.toISOString().split('T')[0]
      }
      // console.log(new Date(time))
      var url = this.$store.state.apiurl + '/alertas_dia/' + fecha.getFullYear() + '/' + (fecha.getMonth() + 1) + '/' + fecha.getDate()
      this.$http.get(url).then((val) => {
        var tdAlerta = (value, key, item) => {
          return item.clase
        }
        var tdDerecha = (value, key, item) => {
          return 'celda_derecha '
        }
        this.alertasFields = [
          {
            "label": "Pluviómetro",
            "key": "pluviometro"
          },
          {
            "label": "Tramos en alerta",
            "key": "tramo"
          },
          {
            "label": "Alerta",
            "key": "tipo"
          },
          {
            "label": "Lluvia 24h (mm)",
            "key": "lluvia24"
          },
          {
            "label": "Lluvia acumulada 30 días (mm)",
            "key": "lluvia30"
          }
        ]
        this.alertasFields[2].tdClass = tdAlerta
        this.alertasFields[3].tdClass = tdDerecha
        this.alertasFields[4].tdClass = tdDerecha
        this.$set(this, "alertasItems", val.data)
      })
      this.$http.get(this.$store.state.apiurl + '/mediciones_acum/' + time).then((val) => {
        // var tdClass = (value, key, item) => {
        //   return 'celda_derecha ' + item.alerta
        // }
        // this.tableFields = val.data.mediciones.fields
        // this.tableItems = val.data.mediciones.data
        // this.tableFields[1].tdClass = tdClass
        // this.tableFields[2].tdClass = tdClass
        // this.tableFields[3].tdClass = tdClass
        this.umbralData = val.data.plot
      })
      url = this.$store.state.apiurl + '/mediciones_mensual/' + fecha.getFullYear() + '/' + (fecha.getMonth() + 1) + '/' + fecha.getDate()
      this.$http.get(url, this.urlconfig).then(function (val) {
        this.chartData = val.data.plot
        this.chartDataTotales = val.data.totales
        this.tableItems = []
        var fields = [{
          'key': 'p',
          'label': 'Pluviómetro'
        }]
        for (var i = 0; i < val.data.mediciones.labels.length; i++) {
          fields.push({
            'key': val.data.mediciones.labels[i].toString(),
            'label': val.data.mediciones.labels[i].toString(),
            'tdClass': (value, key, item) => {
              var resp = ['celda_derecha']
              if (key === fecha.getDate().toString()) resp.push('table-active')
              if (value > 500) resp.push('table-danger')
              else if (value > 300) resp.push('table-info')
              return resp
            }
          })
        }
        this.tableFields = fields
        for (i = 0; i < val.data.mediciones.datasets.length; i++) {
          var data = { 'p': val.data.mediciones.datasets[i].label }
          for (var j = 0; j < val.data.mediciones.labels.length; j++) {
            data[val.data.mediciones.labels[j].toString()] = parseInt(val.data.mediciones.datasets[i].data[j])
            if (isNaN(data[val.data.mediciones.labels[j].toString()])) {
              data[val.data.mediciones.labels[j].toString()] = ''
            }
          }
          this.tableItems.push(data)
        }
        if (obj.pluviometrosArea) {
          obj.mapa.removeLayer(obj.pluviometrosArea)
        }
        obj.pluviometrosArea = new VectorLayer({
          source: new VectorSource({
            features: (new GeoJSON()).readFeatures(val.data.mapa)
          }),
          style: function (feature) {
            var escala = Math.min(Math.max(feature.get('lluvia') / 30, 0), 5)
            return new Style({
              fill: new Fill({
                color: 'rgba(' +
                  String(236 - 99 * escala + 19 * escala * escala) + ',' +
                  String(241 - 26 * escala - 1 * escala * escala) + ',' +
                  String(121 + 73 * escala - 11 * escala * escala) + ',' +
                  '0.8)'
              })
            })
          }
        })
        obj.mapa.addLayer(obj.pluviometrosArea)
        // obj.pluviometrosArea.setZIndex(0)
      })
      /* } */
    },



    style (color) {
      var textStyle = new Text({
        font: '10px, sans-serif',
        text: String(''),
        textBaseline: 'middle',
        textAlign: 'left',
        offsetX: 8,
        offsetY: 3,
        placement: 'line',
        maxAngle: 0,
        fill: new Fill({
          color: 'rgba(0, 0, 0, 1)'
        })
      })
      var style = [ new Style({
        stroke: new Stroke({ color: 'rgba(0,0,0,1.0)', lineDash: null, lineCap: 'round', lineJoin: 'round', width: 7 }),
        text: textStyle
      }), new Style({
        stroke: new Stroke({ color: color, lineDash: null, lineCap: 'round', lineJoin: 'round', width: 5 }),
        text: textStyle
      })]
      return style
    }
  },
  watch: {
    fecha: function (val, orig) {
      var dval = new Date(val)
      this.actualizar(dval)
    }
  },
  computed: {
    mes: function () {
      var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ]
      var f = new Date(this.fecha)
      return meses[f.getMonth()]
    }
  }
}
</script>

<style>
.texto_chico{
  font-size:12px
}
.celda_derecha{
  text-align:right;
}
.monitoreo {
  background: #00AA00;
}
.advertencia {
  background: #FFFF00;
}
.critico {
  background: #FF0000;
}
</style>
